export default {
  timeslots: [],
  selectedTimeslot: null,

  loadingTimeslots: false,
  loadingTimeslotsFailed: false,
  loadingTimeslotsSuccess: false,
  loadingTimeslotsErrors: null,

  saveTimeslotRequest: false,
  saveTimeslotSuccess: false,
  saveTimeslotFailed: false,
  saveTimeslotErrors: null,

  deleteTimeslotsRequest: false,
  deleteTimeslotsSuccess: false,
  deleteTimeslotsFailed: false,
  deleteTimeslotErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/timeslots/state.js